import React, { Component } from 'react';
import '../styles/App.scss';

import About from './About';
import Awards from './Awards';
import Footer from './Footer';
import Intro from './Intro';
import Nav from './Nav';
import Work from './Work';



class App extends Component {
  constructor() {
    super();
    this.state = {
      portfolioItems: [],
      awardItems: [],
    }
  }
  componentDidMount() {
    fetch('./data.json')
      //use promises to format the data into json
      .then(response => response.json())
      //take the result from the json file and process it by creating a variable
      .then(result => {
        //mapping portfolio items
        const items = result.map((item, i) => {
          item.portId = i;
          return item;
        })
        this.setState({
          portfolioItems: items
        });
      });

    fetch('./awards.json')
      //use promises to format the data into json
      .then(response => response.json())
      //take the result from the json file and process it by creating a variable
      .then(result => {
        //mapping portfolio items
        const items = result.map((item, i) => {
          item.awardId = i;
          return item;
        })
        this.setState({
          awardItems: items
        });
      });
  }
  render() {
    return (
      <div className="App">
        <Nav />
        <Intro />
        <Work items = {this.state.portfolioItems} />
        <About />
        <Awards items = {this.state.awardItems} />
        <Footer />
      </div>
    );
  }
}

export default App;
